<template>
  <v-app id="app" ref="app">
    <v-system-bar
      app
      color="error"
      dark
      v-if="!connected && $auth.isAuthenticated && showIfOffline"
    >
      Application Offline: View Only
    </v-system-bar>
    <router-view @login="login"></router-view>
  </v-app>
</template>

<script>
import Template from "./configs/layout";
const app = process.env.VUE_APP_ORG;
export default {
  name: "App",
  data() {
    return {
      templateDoc: Template,
      showIfOffline: false,
    };
  },
  provide() {
    return {
      templateDoc: this.template,
      isAdministrator: this.$auth.isAdmin,
    };
  },
  created() {
    //       var v = this;
    //   setTimeout(function () {
    //     v.showIfOffline = true;
    //   },17000);
  },
  methods: {
    login() {
      if (!this.$auth.isAuthenticated) {
        this.$auth.loginWithRedirect();
      } else {
        // this.lock = true;
        console.log("Logging Out");
        this.$store.dispatch("saved/reset");
        this.$store.dispatch("management/reset");
        localStorage.clear();
        this.$auth.logout({ returnTo: window.location.origin });
      }

      // this.$auth.logout({
      //  returnTo: window.location.origin,
      // });
    },
  },
  computed: {
    template() {
      return this.templateDoc[app] ?? this.templateDoc.default;
    },
    connected() {
      return this.$auth.isAuthenticated ? this.$store.getters["saved/connected"] : true;
    },
  },
};
</script>
